import { action, observable } from "mobx";
import { RouterState } from "mobx-state-router";

import authRepository from "./auth.repository";
import { ok, setAuth, clearAuth } from "shared/utils";

const defaultPanel = new RouterState("homePanel");
const loginPanel = new RouterState("loginPanel");

export class AuthStore {
  //===========================================================================

  rootStore;
  @observable auth = null;
  // Where should we redirect after sign in
  @observable loginRedirect = defaultPanel;

  constructor(rootStore) {
    this.rootStore = rootStore;
  }
  //===========================================================================

  @action
  setAuth(auth) {
    this.auth = auth;
  }
  @action
  clearAuth() {
    this.auth = null;
  }

  @action
  setLoginRedirect(routerState) {
    this.loginRedirect = routerState;
  }
  //===========================================================================

  isLogin() {
    if (!this.auth && sessionStorage.getItem("id")) {
      this.setAuth({
        id: sessionStorage.getItem("id"),
        name: sessionStorage.getItem("name"),
        roleJson: JSON.parse(sessionStorage.getItem("roleJson"))
      });
    }
    return this.auth ? true : false;
  }

  async login(params) {
    const res = await authRepository.login(params);
    ok(this, res, data => {
      let auth = data.auth;
      setAuth(auth);
      if (auth.roleJson) auth.roleJson = JSON.parse(auth.roleJson);
      this.setAuth(auth);
      this.rootStore.routerStore.goTo(this.loginRedirect);
    });
  }

  logout() {
    this.clearAuth();
    clearAuth();
    this.rootStore.routerStore.goTo(loginPanel);
  }

  async changePassword(params) {
    const res = await authRepository.changePassword(params);
    ok(this, res, data => {
      clearAuth();
      this.logout();
    });
  }

  resetLoginRedirect() {
    this.setLoginRedirect(defaultPanel);
  }

  isExistRole(roleUid) {
    let result = false;
    this.auth.roleJson.map(role => {
      if (roleUid === role.uid) result = true;
      return role;
    });
    return result;
  }
}
